import { connect } from 'react-redux'

import { setSlug } from 'components/Modal/DocumentPopupWindow/reducer'

const mapStateToProps = () => {
    return {}
}

const mapDispatchToProps = { setSlug }

const hocCopyright = (InnerComponent) => connect(mapStateToProps, mapDispatchToProps)(InnerComponent)

export default hocCopyright
